<button style="background: transparent; border: 0px;" class="btn-only-icon popover" type="button" disabled 
    [attr.message]="message">
    <img [src]="'assets/icons/' + icon + '.svg'" />
</button>